export default __webpack_public_path__ + "e6ed756b5de28f2a083823fcd4dcd1a8.svg";